import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
export const schema = {
  group: V_FORM_ENUM.custom,
  type: 'jy-vue',
  icon: 'html-text',
  formItemFlag: true,
  label: '自定义组件',
  component: require('./index.vue').default,
  props() {
    return {
      setting: () => import('./setting.vue')
    };
  },
  options: {
    name: '',
    label: '',
    labelAlign: '',
    columnWidth: '200px',
    labelWidth: null,
    labelHidden: false,
    labelWrap: false, // 自动换行
    disabled: false,
    hidden: false,
    // -------------------
    setting: '',
    externalScripts: [],
    vueTemplate: `<div>
  <div>{{ user }}</div>
  <input v-model="fieldModel" type="number" />
  <button @click="add">{{ count }}</button>
  <output>{{ fieldModel }} * {{ count }} = {{ multiply }}</output>
</div>`,
    vueScript: `{
  data: function () {
    return {
      count: 1,
      user: '',
      rules: [{ required: true, message: 'xxxxx' }]
    };
  },
  computed: {
    vmDefaultValue: function () {
      return 1;
    },
    multiply() {
      return this.fieldModel * this.count;
    }
  },
  created: function () {
    var vm = this;
    axios("/user/getUserInfo").then(function (res) {
      vm.user = res.data.name;
    });
  },
  methods: {
    add: function () {
      this.count++;
    }
  }
}`,
    vueStyle: `
.el-input{
}`
  }
};
